module.exports = __webpack_public_path__ + "img/e.9161af6b.jpg";